<template>
    <div>
        <div>
            <v-tabs
                v-model="activeTab"
                slider-color="success"
                class="mt-3 mx-3"
                @change="onTabChanged"
            >
                <v-tab class="mr-3" href="#completed">
                    Completed ({{ statusCounts.completed || 0 }})
                </v-tab>
                <v-tab class="mr-3" href="#active">
                    Active ({{ statusCounts.active || 0 }})
                </v-tab>
                <v-tab class="mr-3" href="#scheduled">
                    Scheduled ({{ statusCounts.scheduled || 0 }})
                </v-tab>
                <v-tab class="mr-3" href="#drafts">
                    Drafts ({{ statusCounts.drafts || 0 }})
                </v-tab>
                <v-tabs-items v-model="activeTab">
                    <v-tab-item
                        v-for="tab in [
                            'completed',
                            'active',
                            'scheduled',
                            'drafts',
                        ]"
                        :key="tab"
                        :value="tab"
                    >
                        <dx-grid
                            v-if="tab == 'completed'"
                            class="broadcast-list"
                            url="broadcastReport?status=COMPLETED"
                            :columns="columns"
                            :title="title"
                            :actions="actions"
                            :onRowClicked="onRowClicked"
                            navigationPath="onRowClicked"
                            navigationField="onRowClicked"
                            ref="grid"
                        ></dx-grid>
                        <dx-grid
                            v-if="tab == 'active'"
                            class="broadcast-list"
                            url="broadcastReport?status=Active"
                            :columns="columns"
                            title="Active"
                            :actions="actions"
                            :onRowClicked="onRowClicked"
                            navigationPath="onRowClicked"
                            navigationField="onRowClicked"
                            ref="activeGrid"
                        ></dx-grid>
                        <dx-grid
                            v-if="tab == 'scheduled'"
                            class="broadcast-list"
                            url="broadcastReport?status=SCHEDULED"
                            :columns="columns"
                            title="Scheduled"
                            :actions="actions"
                            :onRowClicked="onRowClicked"
                            navigationPath="onRowClicked"
                            navigationField="onRowClicked"
                            ref="scheduleGrid"
                        ></dx-grid>
                        <dx-grid
                            v-if="tab == 'drafts'"
                            class="broadcast-list"
                            url="broadcastDrafts"
                            :columns="broadcastDraftsColumns"
                            title="Drafts"
                            :actions="draftActions"
                            :onRowClicked="onRowClicked"
                            navigationPath="onRowClicked"
                            navigationField="onRowClicked"
                            :selectionEnabled="true"
                            ref="draftGrid"
                        ></dx-grid>
                    </v-tab-item>
                </v-tabs-items>
            </v-tabs>
        </div>

        <v-dialog v-model="callsDialog" max-width="1400">
            <v-card class="pa-3">
                <v-layout
                    row
                    class="px-3 pt-3 pb-2 mb-2 ma-1"
                    style="border: 2px solid #43a047; border-radius: 6px;"
                >
                    <v-layout column style="width: 50%">
                        <div class="mb-2">
                            <v-layout row class="pa-0">
                                <div class="font-weight-medium mr-3">
                                    {{ selectedCall.broadcastName }}
                                </div>

                                <div
                                    class="cyan caption pa-1"
                                    style="color: #fff"
                                >
                                    {{ selectedCall.accountsSource }}
                                </div>
                            </v-layout>
                            <div class="body-1">Name</div>
                        </div>
                        <div class="mb-2">
                            <div class="font-weight-medium">
                                {{ selectedCall.fromNumber }}
                            </div>
                            <div class="body-1">Caller ID</div>
                        </div>
                        <div class="mb-2">
                            <div class="font-weight-medium">
                                {{ selectedCall.userName }}
                            </div>
                            <div class="body-1">User</div>
                        </div>
                        <div class="mb-2">
                            <div class="font-weight-medium">
                                {{ selectedCall.date | time }}
                            </div>
                            <div class="body-1">Date</div>
                        </div>

                        <div class="mb-0">
                            <audio
                                controls
                                :src="selectedCall.audioFile"
                            ></audio>
                        </div>
                    </v-layout>
                    <v-layout column style="width: 50%">
                        <div class="mb-3">
                            <div class="font-weight-medium">
                                {{ selectedCall.totalCount }}
                            </div>
                            <div class="body-1">Total Calls</div>
                        </div>
                        <div class="mb-3">
                            <div class="font-weight-medium">
                                {{ selectedCall.completed || 0 }}
                            </div>
                            <div class="body-1">Completed</div>
                        </div>
                        <div class="mb-3">
                            <div class="font-weight-medium">
                                {{ getCallsInProcess() }}
                            </div>
                            <div class="body-1">In Progress</div>
                        </div>
                        <div class="mb-2">
                            <div class="font-weight-medium">
                                {{ selectedCall.queued || 0 }}
                            </div>
                            <div class="body-1">Queued</div>
                        </div>
                        <v-btn
                            style="width: 100px;"
                            color="success"
                            small
                            @click="reuseBroadcast(selectedCall)"
                            >Reuse</v-btn
                        >
                    </v-layout>
                </v-layout>
                <data-grid
                    class="call-grid"
                    name="broadcast-call-logs"
                    v-if="showCallsTable"
                    :url="callUrl"
                    :columns="callColumns"
                    title="Call Log"
                    :sortOptions="{
                        enabled: true,
                        field: 'date',
                        type: 'desc',
                    }"
                    ref="callGrid"
                ></data-grid>
                <v-card-actions class="mr-0 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="callsDialog = false"
                        >Close</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="smsDialog" max-width="1400">
            <v-card class="pa-3">
                <v-layout
                    row
                    class="px-3 pt-3 pb-2 mb-2 ma-1"
                    style="border: 2px solid #43a047; border-radius: 6px;"
                >
                    <v-layout column style="width: 50%">
                        <div class="mb-3">
                            <v-layout row class="pa-0">
                                <div class="font-weight-medium mr-3">
                                    {{ selectedMessage.broadcastName }}
                                </div>

                                <div
                                    class="cyan caption pa-1"
                                    style="color: #fff"
                                >
                                    {{ selectedMessage.accountsSource }}
                                </div>
                            </v-layout>
                            <div class="body-1">Name</div>
                        </div>
                        <div class="mb-3">
                            <div class="font-weight-medium">
                                {{ selectedMessage.fromNumber }}
                            </div>
                            <div class="body-1">Caller ID</div>
                        </div>
                        <div class="mb-3">
                            <div class="font-weight-medium">
                                {{ selectedMessage.userName }}
                            </div>
                            <div class="body-1">User</div>
                        </div>
                        <div class="mb-0">
                            <div class="font-weight-medium">
                                {{ selectedMessage.date | time }}
                            </div>
                            <div class="body-1">Date</div>
                        </div>
                    </v-layout>
                    <v-layout column style="width: 50%">
                        <div class="mb-2">
                            <div class="font-weight-medium">
                                {{ selectedMessage.totalCount }}
                            </div>
                            <div class="body-1">Total Messages</div>
                        </div>
                        <!-- <div class="mb-2">
                                <div class="font-weight-medium">
                                    {{ selectedMessage.completed }}
                                </div>
                                <div class="body-1">Completed</div>
                            </div>
                            <div class="mb-3">
                                <div class="font-weight-medium">
                                    {{ getMessagesInProcess() }}
                                </div>
                                <div class="body-1">In Progress</div>
                            </div> -->

                        <v-layout row wrap class="my-1">
                            <div
                                class="mr-4"
                                v-for="status in selectedMessage.statuses"
                            >
                                <div class="font-weight-medium">
                                    {{ status.count }}
                                </div>
                                <div class="body-1">
                                    {{ status.status.toUpperCase() }}
                                </div>
                            </div>
                        </v-layout>

                        <v-layout row class="">
                            <div class="font-weight-medium mr-2">Text:</div>
                            <div style="font-size: 13px" class="mt-0">
                                {{ selectedMessage.text }}
                            </div>
                        </v-layout>

                        <v-btn
                            style="width: 100px;"
                            color="success"
                            small
                            @click="reuseBroadcast(selectedMessage)"
                            >Reuse</v-btn
                        >
                    </v-layout>
                </v-layout>
                <data-grid
                    class="call-grid"
                    name="broadcast-sms-logs"
                    v-if="showSmsTable"
                    :url="smsUrl"
                    :columns="smsColumns"
                    title="Messages Log"
                    :sortOptions="{
                        enabled: true,
                        field: 'dateTime',
                        type: 'desc',
                    }"
                    ref="smsGrid"
                ></data-grid>
                <v-card-actions class="mr-0 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="smsDialog = false"
                        >Close</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="broadcastDialog" max-width="1200">
            <broadcast-call
                :closeDialog="closeBroadcastDialog"
                :openSnakbar="openSnakbar"
                ref="broadcastDialog"
            ></broadcast-call>
        </v-dialog>

        <v-dialog v-model="confirmDeleteDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0">
                    Are you sure?
                </v-card-title>
                <div class="mb-3">This will delete the selected drafts</div>
                <v-card-actions class="mr-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="confirmDeleteDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn color="success" @click="deleteDrafts()"
                        >Delete</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-snackbar
            color="info"
            top
            right
            :timeout="snackbarTimeout"
            v-model="processingCallsSnackbar"
            dark
        >
            <v-layout column>
                <div class="headline mb-2">
                    {{ processingCalls }}
                </div>
            </v-layout>
            <v-icon size="16" @click="processingCallsSnackbar = false">
                mdi-close-circle
            </v-icon>
        </v-snackbar>
    </div></template
>
<script>
import moment from "moment";
import * as firebase from "firebase/app";
import "firebase/database";
import broadcastCall from "./BroadcastCall.vue";

export default {
    components: {
        broadcastCall,
    },
    data: () => ({
        title: "Broadcasts",
        callsDialog: false,
        smsDialog: false,
        showCallsTable: false,
        showSmsTable: false,
        callUrl: "",
        smsUrl: "",
        selectedCall: "",
        selectedMessage: "",
        actions: [],
        draftActions: [],

        snackbarTimeout: 0,
        processingCallsSnackbar: false,
        processingCalls: "",
        requestID: "",

        broadcastDialog: false,
        confirmDeleteDialog: false,
        activeTab: "completed",
        statusCounts: "",

        columns: [
            {
                label: "Broadcat Name",
                field: "broadcastName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "date",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "User",
                field: "userName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "From",
                field: "fromNumber",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Audio",
                field: "audioFile",
                template: "link-audio-cell-template",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Broadcast Time",
                field: "broadcastTime",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Broadcast Status",
                field: "broadcastStatus",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Carrier",
                field: "carrier",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Text",
                field: "text",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Type",
                field: "type",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Total Count",
                field: "totalCount",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Completed",
                field: "completed",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Source",
                field: "source",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Queued",
                field: "queued",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "In Process",
                field: "inProcess",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Delivered",
                field: "delivered",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Undelivered",
                field: "undelivered",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Sent",
                field: "sent",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "New",
                field: "new",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Waiting",
                field: "waiting",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Failed",
                field: "failed",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Error",
                field: "error",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Unknown",
                field: "unknown",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],

        broadcastDraftsColumns: [
            {
                label: "Broadcat Name",
                field: "broadcastName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "date",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "User",
                field: "userName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Caller ID",
                field: "fromNumber",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Audio",
                field: "audioFile",
                template: "link-audio-cell-template",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Broadcast Time",
                field: "broadcastTime",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Broadcast Status",
                field: "broadcastStatus",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Text",
                field: "text",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Type",
                field: "type",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Source",
                field: "source",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],

        callColumns: [
            {
                field: "status",
                isIcon: true,
                icon: (value) => {
                    if (!value) return "mdi-clock";

                    switch (value.trim()) {
                        case "COMPLETED":
                            return "mdi-check-circle";
                        case "BUSY":
                            return "mdi-phone-missed";
                        case "OUT OF SERVICE":
                            return "mdi-phone-remove";
                        case "UNKNOWN":
                            return "mdi-phone";
                        case "ERROR":
                            return "mdi-alert-circle";
                        default:
                            return "";
                    }
                },
                iconColor: (value) => {
                    if (!value) return "#fdb400";

                    switch (value.trim()) {
                        case "COMPLETED":
                            return "success";
                        case "ERROR":
                            return "#f35123";
                        case "OUT OF SERVICE":
                            return "#f35123";
                        case "UNKNOWN":
                            return "#aeb8bf";
                        case "BUSY":
                            return "#aeb8bf";
                        default:
                            return "#aeb8bf";
                    }
                },
            },
            {
                sortable: false,
                label: "Account ID",
                field: "accountID",
                link: (row) => {
                    return row.accountsSource == "DINNER"
                        ? "DinnerAccountView"
                        : "Account View";
                },
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: true,
                label: "Name",
                field: "name",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Hebrew Name",
                field: "nameH",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: true,
                label: "Date",
                field: "date",
                type: "date",
                dateOutputFormat: "MM/DD/YYYY h:mm:ss A",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "From",
                field: "from",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "To",
                field: "to",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Direction",
                field: "direction",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Status",
                field: "status",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    filterDropdownItems: [
                        "ERROR",
                        "COMPLETED",
                        "OUT OF SERVICE",
                        "BUSY",
                        "UNKNOWN",
                    ],
                },
            },
        ],

        smsColumns: [
            {
                field: "status",
                isIcon: true,
                icon: (value) => {
                    if (!value) return "";

                    switch (value.trim()) {
                        case "ERROR":
                        case "FAILED":
                            return "mdi-message-alert";
                        case "NEW":
                            return "mdi-message-plus";
                        case "QUEUED":
                        case "WAITING":
                        case "PENDING":
                            return "mdi-message-processing";
                        case "SENT":
                            return "mdi-comment-arrow-right";
                        case "UNKNOWN":
                            return "mdi-message-question";
                        case "DELIVERED":
                            return "mdi-message-text";
                        case "UNDELIVERED":
                            return "mdi-close-circle";
                        default:
                            return "";
                    }
                },
                iconColor: (value) => {
                    if (!value) return "";

                    switch (value.trim()) {
                        case "ERROR":
                        case "FAILED":
                        case "UNDELIVERED":
                            return "#f35123";
                        case "NEW":
                            return "info";
                        case "QUEUED":
                        case "WAITING":
                        case "PENDING":
                            return "#fdb400";
                        case "DELIVERED":
                            return "success";
                        case "SENT":
                        case "UNKNOWN":
                            return "#aeb8bf";
                        default:
                            return "#aeb8bf";
                    }
                },
            },
            {
                sortable: true,
                label: "Date",
                field: "dateTime",
                type: "date",
                dateOutputFormat: "MM/DD/YYYY h:mm:ss A",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Account ID",
                field: "accountId",
                link: (row) => {
                    return row.accountsSource == "DINNER"
                        ? "DinnerAccountView"
                        : "Account View";
                },
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: true,
                label: "Name",
                field: "name",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Hebrew Name",
                field: "nameH",
                hidden: true,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: true,
                label: "To",
                field: "to",
                formatFn: (value) => {
                    return value.replace(
                        /(\d{1})(\d{3})(\d{3})(\d{4})/,
                        "$1 ($2) $3-$4",
                    );
                },
                searchValue: (value) => {
                    return value.replace(/[-() ]/g, "");
                },
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: true,
                label: "Status",
                field: "status",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    filterDropdownItems: [
                        "QUEUED",
                        "PENDING",
                        "FAILED",
                        "SENT",
                        "UNDELIVERED",
                        "ERROR",
                        "DELIVERED",
                        "WAITING",
                        "NEW",
                        "UNKNOWN",
                    ],
                },
            },
            {
                sortable: false,
                label: "Text",
                field: "text",
                hidden: true,
                filterOptions: {
                    enabled: true,
                },
            },
        ],
    }),
    mounted() {
        if (this.$route.query.reuseBroadcast) {
            this.broadcat(this.$route.query.broadcastID);

            // this.$refs.broadcastDialog.loadDraft(
            //     this.$route.query.broadcastID.toString(),
            //     true,
            // );
        }
    },
    created() {
        this.firebaseSetup();

        this.actions.push({
            text: "New Broadcat",
            action: () => this.broadcat(),
            showOnSelection: false,
        });

        this.draftActions.push({
            text: "Delete",
            action: this.openDeleteDraftDialog,
            showOnSelection: true,
        });

        this.subscribeToPusher();
        this.loadStatusCount();
    },
    beforeDestroy() {
        this.pusher.unsubscribe("broadcast");
    },
    methods: {
        broadcat(id = null) {
            //this.broadcastDialog = true;

            //this.$refs.broadcastDialog.loadAudioLibrary();

            this.$router.push({
                name: "NewBroadcast",
                params: { id: id },
            });
        },
        async onRowClicked(row) {
            if (this.activeTab == "drafts") {
                this.broadcat(row.id);

                //await this.$refs.broadcastDialog.loadBroadcasts();

                //this.$refs.broadcastDialog.loadDraft(row.id.toString());

                return;
            }

            if (row.type == "CALL") {
                this.$router.push({
                    name: "BroadcastCalls",
                    params: { id: row.id },
                });
            } else if (row.type == "EMAIL") {
                this.$router.push({
                    name: "BroadcastEmails",
                    params: { id: row.id },
                });
            } else {
                this.$router.push({
                    name: "BroadcastMessages",
                    params: { id: row.id },
                });
            }
        },
        reuseBroadcast(broadcast) {
            // if (broadcast.type == "CALL") {
            //     this.callsDialog = false;
            // } else {
            //     this.smsDialog = false;
            // }

            this.broadcat(broadcast.id);

            //this.$refs.broadcastDialog.loadDraft(broadcast.id.toString(), true);
        },
        openDeleteDraftDialog(selected) {
            this.confirmDeleteDialog = true;
        },
        async deleteDrafts() {
            const selected = this.$refs.draftGrid[0].getSelectedRowsData();

            try {
                this.processing = true;

                await this.$http.post(
                    "api/broadcast/deleteDraft",
                    selected.map((s) => s.id),
                );

                this.confirmDeleteDialog = false;
                this.processing = false;
                this.$refs.draftGrid[0].reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        getCallsInProcess() {
            const pending =
                this.selectedCall.totalCount -
                (this.selectedCall.completed || 0);

            const inProcess = pending - (this.selectedCall.queued || 0);

            return inProcess >= 0 ? inProcess : 0;
        },
        getMessagesInProcess() {
            return (
                this.selectedMessage.totalCount -
                (this.selectedMessage.completed || 0)
            );
        },
        subscribeToPusher() {
            this.pusher = new Pusher("33b9d9d711ad50d8a7ef", {
                cluster: "mt1",
            });

            var channel = this.pusher.subscribe("broadcast");

            this.pusher.connection.bind("error", function(err) {
                console.log(err);
            });

            channel.bind("broadcast-call", (call) => {
                this.updateProcessingCalls(call);
            });
        },
        updateProcessingCalls(call) {
            if (call.requestID != this.requestID) return;

            if (call.index == call.total) {
                this.processingCalls = "";
                this.processingCallsSnackbar = false;
            } else {
                this.processingCalls =
                    call.index + "/" + call.total + " " + call.text;
            }
        },
        async loadStatusCount() {
            this.statusCounts = await this.$http.get(
                "api/broadcastReport/getStatusCount",
            );
        },
        closeBroadcastDialog(activeTab = null) {
            this.broadcastDialog = false;

            if (!activeTab) return;

            this.activeTab = activeTab;

            this.loadStatusCount();

            this.onTabChanged(this.activeTab);
        },
        onTabChanged(value) {
            if (this.activeTab == "completed" && this.$refs.grid) {
                this.$refs.grid[0].reloadGrid();
            } else if (this.activeTab == "active" && this.$refs.activeGrid) {
                this.$refs.activeGrid[0].reloadGrid();
            } else if (
                this.activeTab == "scheduled" &&
                this.$refs.scheduleGrid
            ) {
                this.$refs.scheduleGrid[0].reloadGrid();
            } else if (this.$refs.draftGrid) {
                this.$refs.draftGrid[0].reloadGrid();
            }
        },
        openSnakbar(requestID) {
            this.requestID = requestID;

            this.processingCallsSnackbar = true;
        },
        firebaseSetup() {
            const firebaseConfig = {
                apiKey: "AIzaSyCtYeCL8HkqlMKJh6g6jcDvoH60-woVbDE",
                authDomain: "utaw.firebaseapp.com",
                databaseURL: "https://utaw.firebaseio.com",
                projectId: "project-683582246459980907",
                storageBucket: "project-683582246459980907.appspot.com",
                messagingSenderId: "193425158146",
                appId: "1:193425158146:web:f1ae134a803fb75832371b",
            };

            // Initialize Firebase
            if (!firebase.apps.length) {
                firebase.initializeApp(firebaseConfig);
            }

            const database = firebase.database();
            const callRef = firebase.database().ref("broadcast-call-progress");

            const callQuery = callRef.limitToLast(10);

            callQuery.on(
                "value",
                (snapshot) => {
                    Object.values(snapshot.val()).map((call) => {
                        if (
                            this.$refs.grid &&
                            this.$refs.grid.grid &&
                            this.$refs.grid.grid.getDataSource()
                        ) {
                            this.$refs.grid.grid
                                .getDataSource()
                                .items()
                                .forEach((c) => {
                                    if (c.id != call.BroadcastID) return;

                                    c.completed = call.Count;
                                    c.queued = call.PendingCalls;
                                });
                        }
                    });
                },
                function(error) {
                    console.log("Error: " + error.code);
                },
            );

            const messageRef = firebase
                .database()
                .ref("broadcast-message-progress");

            const messageQuery = messageRef.limitToLast(10);

            messageQuery.on(
                "value",
                (snapshot) => {
                    Object.values(snapshot.val()).map((message) => {
                        if (
                            this.$refs.grid &&
                            this.$refs.grid.grid &&
                            this.$refs.grid.grid.getDataSource()
                        ) {
                            this.$refs.grid.grid
                                .getDataSource()
                                .items()
                                .forEach((m) => {
                                    if (m.id != message.BroadcastID) return;

                                    m.completed = message.Count;
                                });
                        }
                    });
                },
                function(error) {
                    console.log("Error: " + error.code);
                },
            );
        },
    },
};
</script>
<style>
.call-grid.container {
    padding-left: 0px !important;
    padding-right: 0px !important;
    padding-bottom: 0px !important;
}
.call-grid .flex {
    padding: 0px !important;
}
.call-grid .per-page {
    margin-top: 16px !important;
    margin-right: 34px;
}
.call-grid .v-card {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2), 0 0 0 0 rgba(0, 0, 0, 0.14),
        0 0 0 0 rgba(0, 0, 0, 0.12) !important;
}
.broadcast-list.container {
    padding-right: 0px !important;
    padding-left: 0px !important;
}
</style>
